import BaseModel from '@/app-core/lib/data/model/BaseModel'
import LoginValidator from '@/app-core/api/validations/user/LoginValidator'
import LoginResource from '@/app-core/api/resources/user/LoginResource'

export default class LoginModel extends BaseModel {
  constructor(payload = {}, resource = LoginResource, validator = LoginValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
